"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import DisablingButton from "../disabling_button";
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
    __publicField(this, "mounted", false);
    __publicField(this, "resolveException", () => {
      this.props.recentlyResolved(this.props.exception);
      var self = this;
      var exception = self.props.exception;
      self.setState({ saving: true });
      self.props.exceptionResolver(exception, self.props.owner).then(function() {
        if (self.mounted) {
          self.setState({ saving: false });
        }
      });
    });
    __publicField(this, "resolveButton", () => {
      return /* @__PURE__ */ jsx(
        DisablingButton,
        {
          disabled: this.state.saving,
          disabledText: "Saving...",
          className: "rules__save-resolution-button",
          onClick: this.resolveException,
          children: "Remove This Exception"
        }
      );
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    var exception = this.props.exception;
    var itemClasses = classNames({
      rules__item: true
    });
    var exceptionClasses = classNames({
      rules__item: true,
      rules__ignored: exception.resolved_at
    });
    return /* @__PURE__ */ jsxs("li", { className: itemClasses, children: [
      /* @__PURE__ */ jsx("span", { className: exceptionClasses, children: /* @__PURE__ */ jsx("span", { className: "text", children: exception.message_override }) }),
      this.resolveButton()
    ] });
  }
}
